import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { BrokerService } from '@c4/core';

import { Device } from '../../../common/interfaces/item.interface';
import { DeviceEvent } from '../../../common/interfaces/event.interface';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { SharedProgrammingService } from '../../../common/services/shared-programming.service';
import { EventType } from '../event-types/event-type.interface';
import { EventTypes } from '../event-types/event-types';
import { BLINDS } from '../event-types/blinds.type';
import { SimpleProgrammingContext, SIMPLE_ACTIONS } from '../quickstart-simple.service';

@Component({
  templateUrl: './select-event.component.html',
  styleUrls: ['../select-device/select-device.component.less']
})
export class QSSimpleSelectEventComponent extends BaseRoutingComponent {

  private _device: Observable<Device>;
  private _events: Observable<DeviceEvent[]>;
  private _eventType: Observable<EventType>;

  constructor(
    private _route: ActivatedRoute,
    protected store: Store<{
      simpleProgramming: SimpleProgrammingContext
    }>,
    public router: Router,
    private _broker: BrokerService,
    private _shared: SharedProgrammingService
  ) {
    super();

    this._device = Observable.combineLatest(
      this._route.params.map((params: { id: string }) => parseInt(params.id)),
      this.store.select(s => s.simpleProgramming.devices).filter(d => !!d),
      (id, devices) => devices.find(d => d.id == id)
    );

    this._eventType = this._device
      .filter(d => !!d)
      .map(d => d.proxy)
      .map(proxy => {
        return EventTypes.find(et => {
          return et.whitelist.map(w => w.proxy).indexOf(proxy) > -1;
        })
      })

    this._events = this._device.filter(d => !!d).flatMap(device => {
      return Observable.fromPromise(this._broker.call({
        path: `/api/v1/items/${device.id}/events`,
        queryString: {
          allEvents: true
        }
      }))
        .map((events: DeviceEvent[]) => {
          return events.filter(event => {

            let eventType = EventTypes.find(et => et.whitelist.map(w => w.proxy).indexOf(device.proxy) > -1);
            let whitelist = eventType.whitelist.find(w => w.proxy == device.proxy).events;

            if (eventType.route == BLINDS.route) {
              return whitelist.indexOf(event.eventId) > -1 && event.deviceId != device.protocolId;
            }

            return whitelist.indexOf(event.eventId) > -1;
          });
        });
    });
  }

  selectEvent(event: DeviceEvent) {
    this._shared.setSelectedEvent(event);
    this.router.navigate([['when-then', 'device', event.deviceId, 'event', event.eventId, 'add'].join('/')], { relativeTo: this.moduleRoot });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/select-event/select-event.component.ts